import React, { useMemo, useState } from "react";

import { Eyebrow, Title } from "../components/CommonComponents";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import ordinance6978 from "../assets/docs/ISBM-Ordinance-69-78-15-May-2023.pdf";
import nepOrdinance79 from "../assets/docs/ISBM-NEP-Ordinance-03-09-2024.pdf";
import rajyapatra from "../assets/docs/RAJYAPATRA-16052021.pdf";
import stateGovernmentNoc from "../assets/docs/State-Government-NOC-University-Establishment.pdf";
import iauAdmissionLetter from "../assets/docs/A2535-Letter of Admission from IAU to ISBM University.pdf";
import aacsbMembershipCertificate from "../assets/docs/Membership Certificate- AACSB.pdf";
import academicCouncilMinutes from "../assets/docs/MOM of AC meeting 25112022.pdf";
import boardOfManagementMinutes from "../assets/docs/MOM of BOM meeting 25112022.pdf";
import governingBodyMinutes from "../assets/docs/MOM of GB meeting 25112022.pdf";

import statutesHeroImage from "../assets/img/about/university-administration.png"

const documents = [
    {
        number: "01",
        category: "Ordinances",
        title: "ISBM Ordinance 69 - 78 - 15 May 2023",
        meta: "Ordinance No. 69 to 78",
        href: ordinance6978,
    },
    {
        number: "02",
        category: "NEP Ordinance",
        title: "ISBM NEP Ordinance 03 - 09 - 2024",
        meta: "Ordinance No. 79",
        href: nepOrdinance79,
    },
    {
        number: "03",
        category: "Gazette",
        title: "RAJYAPATRA 16052021",
        meta: "Chhattisgarh Rajpatra",
        href: rajyapatra,
    },
    {
        number: "04",
        category: "State Government",
        title: "State Government NOC University Establishment",
        meta: "University Establishment",
        href: stateGovernmentNoc,
    },
    {
        number: "05",
        category: "International Membership",
        title: "Letter of Admission from IAU to ISBM University",
        meta: "International Association of Universities",
        href: iauAdmissionLetter,
    },
    {
        number: "06",
        category: "Membership Certificate",
        title: "AACSB Membership Certificate",
        meta: "ISBM University - School of Management",
        href: aacsbMembershipCertificate,
    },
    {
        number: "07",
        category: "Meeting Minutes",
        title: "Minutes of the Meeting - Academic Council",
        meta: "Academic Council, ISBM University",
        href: academicCouncilMinutes,
    },
    {
        number: "08",
        category: "Meeting Minutes",
        title: "Minutes of the Meeting - Board of Management",
        meta: "Board of Management, ISBM University",
        href: boardOfManagementMinutes,
    },
    {
        number: "09",
        category: "Meeting Minutes",
        title: "Minutes of the Meeting - Governing Body",
        meta: "Governing Body, ISBM University",
        href: governingBodyMinutes,
    },
];

const ArrowUpRight = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const DocumentIcon = ({ className = "h-6 w-6" }) => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
        <path d="M7 3.75h6.7L18 8.05V20.25H7V3.75Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M13.5 3.75v4.5H18M9.5 12h6M9.5 15.5h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Arrow = () => (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path
            d="M5 12h14M14 7l5 5-5 5"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const Download = () => (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
        <path
            d="M12 4v10m0 0 4-4m-4 4-4-4M5 19h14"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function StatutesAndOrdinances() {
    const [activeCategory, setActiveCategory] = useState("All Documents");

    const categories = ["All Documents", ...new Set(documents.map((item) => item.category))];

    const filteredDocuments = useMemo(() => {
        if (activeCategory === "All Documents") return documents;
        return documents.filter((item) => item.category === activeCategory);
    }, [activeCategory]);

    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="overflow-hidden bg-white">
                {/* MODERN HERO */}
                <section className="relative isolate min-h-[60vh] overflow-hidden bg-[#071A2F] text-white">
                    <div className="absolute inset-0 -z-30 bg-[radial-gradient(circle_at_78%_18%,rgba(213,173,87,0.18),transparent_25%),radial-gradient(circle_at_18%_78%,rgba(139,30,63,0.22),transparent_28%)]" />
                    <div className="absolute inset-0 -z-20 opacity-[0.08] [background-image:linear-gradient(rgba(255,255,255,.35)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.35)_1px,transparent_1px)] [background-size:64px_64px]" />
                    <div className="absolute right-[-180px] top-[80px] -z-10 h-[600px] w-[600px] rounded-full border border-white/10" />
                    <div className="absolute right-[-70px] top-[190px] -z-10 h-[380px] w-[380px] rounded-full border border-[#D5AD57]/20" />

                    <div className="grid gap-16 lg:grid-cols-[1.26fr_.84fr] mx-auto min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-center pb-20 pt-[190px] max-sm:w-[calc(100%-28px)] lg:min-h-[60vh] lg:pb-24">
                        <div>
                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                University Governance
                            </div>

                            <h1 className="mt-7 max-w-[820px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.8vw,96px)] font-normal leading-[0.94] tracking-[-0.05em]">
                                Statutes &
                                <span className="block text-[#D5AD57]">Ordinances</span>
                            </h1>

                            <p className="mt-8 max-w-[690px] text-[17px] leading-8 text-white/65">
                                Access the University's approved ordinances and academic
                                regulatory provisions governing programmes, academic structures
                                and implementation under the applicable framework.
                            </p>

                            <div className="mt-10 flex flex-wrap gap-4">
                                <a
                                    href="#ordinance-register"
                                    className="inline-flex min-h-[54px] items-center gap-7 rounded-full bg-[#D5AD57] px-7 text-xs font-bold uppercase tracking-[0.12em] text-[#071A2F] transition hover:-translate-y-0.5"
                                >
                                    Explore Ordinances
                                    <Arrow />
                                </a>

                                <a
                                    href="#documents"
                                    className="inline-flex min-h-[54px] items-center gap-7 rounded-full border border-white/20 px-7 text-xs font-bold uppercase tracking-[0.12em] text-white transition hover:border-white/50"
                                >
                                    Official Documents
                                    <Download />
                                </a>
                            </div>
                        </div>

                        <div className="relative hidden min-h-[500px] lg:block">
                            <div className="absolute right-0 top-0 h-[470px] w-[520px] overflow-hidden rounded-[34px] border border-white/10 bg-white/[0.04] shadow-[0_30px_80px_rgba(0,0,0,0.28)]">
                                <img src={statutesHeroImage} alt="ISBM University Statutes and Ordinances" className="h-full w-full object-cover" />
                                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(7,26,47,0.05)_0%,rgba(7,26,47,0.18)_45%,rgba(7,26,47,0.92)_100%)]" />

                                <div className="absolute left-6 top-6 flex items-center gap-3 rounded-full border border-white/15 bg-[#071A2F]/55 px-4 py-2 backdrop-blur-md">
                                    <span className="h-2 w-2 rounded-full bg-[#D5AD57]" />
                                    <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-white">Academic Framework</span>
                                </div>
                            </div>

                            <div className="absolute right-[-18px] top-[38px] h-[150px] w-[150px] rounded-full border border-[#D5AD57]/20" />
                        </div>
                    </div>
                </section>

                <section className="bg-white py-20 sm:py-24 lg:py-28">
                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_auto] lg:items-end">
                            <div>
                                <Eyebrow>University Documents</Eyebrow>
                                <Title before="Statutes" highlight="And Ordinances" after="" position="middle" theme="burgundy" />
                            </div>

                            <div className="flex flex-wrap gap-2 lg:max-w-[560px] lg:justify-end">
                                {categories.map((category) => (
                                    <button key={category} type="button" onClick={() => setActiveCategory(category)} className={`min-h-[42px] border px-4 text-xs font-bold uppercase tracking-[0.1em] transition ${activeCategory === category ? "border-[#071A2F] bg-[#071A2F] text-white" : "border-[#071A2F]/15 bg-white text-[#071A2F] hover:border-[#8B1E3F] hover:text-[#8B1E3F]"}`}>
                                        {category}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="mt-12 grid gap-5 lg:grid-cols-2">
                            {filteredDocuments.map((document, index) => (
                                <article key={document.title} className={`group relative overflow-hidden border border-[#071A2F]/10 ${index % 4 === 0 ? "bg-[#F7F2E8]" : index % 4 === 1 ? "bg-[#EEF4F8]" : index % 4 === 2 ? "bg-[#F4E8EC]" : "bg-white"}`}>
                                    <div className="grid min-h-[270px] sm:grid-cols-[150px_1fr]">
                                        <div className="relative flex flex-col justify-between bg-[#071A2F] p-6 text-white">
                                            <span className="text-xs font-bold uppercase tracking-[0.15em] text-[#D5AD57]">{document.category}</span>
                                            <div>
                                                <DocumentIcon className="h-9 w-9 text-[#D5AD57]" />
                                                <span className="mt-6 block font-['Libre_Caslon_Display',Georgia,serif] text-[44px] font-normal leading-none text-white/90">{document.number}</span>
                                            </div>
                                        </div>

                                        <div className="flex flex-col justify-between p-7 sm:p-8">
                                            <div>
                                                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">{document.meta}</span>
                                                <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal leading-[1.15] text-[#071A2F]">{document.title}</h2>
                                            </div>

                                            <div className="mt-8 flex flex-wrap items-center gap-3">
                                                <a href={document.href} target="_blank" rel="noreferrer" className="group/link inline-flex min-h-[48px] items-center gap-6 bg-[#071A2F] px-5 text-xs font-bold uppercase tracking-[0.1em] text-white transition hover:bg-[#8B1E3F]">
                                                    View Document
                                                    <ArrowUpRight className="h-4 w-4 transition-transform group-hover/link:translate-x-1 group-hover/link:-translate-y-1" />
                                                </a>

                                                <a href={document.href} download className="inline-flex min-h-[48px] items-center border border-[#071A2F]/15 px-5 text-xs font-bold uppercase tracking-[0.1em] text-[#071A2F] transition hover:border-[#8B1E3F] hover:text-[#8B1E3F]">
                                                    Download PDF
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </>
    );
}
